/* HobbyChef — návrhář umístění gravírování na obrysu konkrétního nože.
   Zatím jen v testovacím tématu „TEST gravírování – nepublikovat“.
   Data obrysu nese produkt v metafieldu gravirovani.obrys (JSON, vše v mm):
   počátek = pata čepele u záštity na hřbetu, osa x ke špičce, osa y dolů k ostří.
   Zadní strana se kreslí zrcadlově (x záporné), aby zákazník viděl nůž tak,
   jak ho drží v ruce. Text a písmo bere z polí konfigurátoru hc-engrave. */
(function () {
  'use strict';

  var NS = 'http://www.w3.org/2000/svg';
  /* Pořadí odpovídá radiím písma v hc-engrave (Klasické, Moderní, Psané, Verzálky)
     a stylům náhledu v hc-product-main. cap = výška velkých písmen / velikost písma. */
  var FONTS = [
    { v: '--hc-font-serif', fb: 'Georgia, serif', cap: 0.68, ls: 0 },
    { v: '--hc-font-sans', fb: 'Arial, sans-serif', cap: 0.72, ls: 0.04 },
    { fam: "'Cormorant Garamond'", v: '--hc-font-serif', fb: 'Georgia, serif', cap: 0.62, ls: 0, italic: true },
    { v: '--hc-font-sans', fb: 'Arial, sans-serif', cap: 0.72, ls: 0.18, upper: true }
  ];
  var ctx = document.createElement('canvas').getContext('2d');
  var uid = 0;

  function fmt(n) {
    return (Math.round(n * 10) / 10).toLocaleString('cs-CZ', { minimumFractionDigits: 1, maximumFractionDigits: 1 });
  }
  function el(name, attrs, parent) {
    var e = document.createElementNS(NS, name);
    for (var a in attrs) if (Object.prototype.hasOwnProperty.call(attrs, a)) e.setAttribute(a, attrs[a]);
    if (parent) parent.appendChild(e);
    return e;
  }
  function inPoly(x, y, P) {
    var c = false;
    for (var i = 0, j = P.length - 1; i < P.length; j = i++) {
      var xi = P[i][0], yi = P[i][1], xj = P[j][0], yj = P[j][1];
      if ((yi > y) !== (yj > y) && x < (xj - xi) * (y - yi) / (yj - yi) + xi) c = !c;
    }
    return c;
  }
  function distEdge(x, y, P) {
    var m = Infinity;
    for (var i = 0, j = P.length - 1; i < P.length; j = i++) {
      var x1 = P[j][0], y1 = P[j][1], dx = P[i][0] - x1, dy = P[i][1] - y1;
      var t = Math.max(0, Math.min(1, ((x - x1) * dx + (y - y1) * dy) / (dx * dx + dy * dy || 1)));
      m = Math.min(m, Math.hypot(x - (x1 + t * dx), y - (y1 + t * dy)));
    }
    return m;
  }

  function init(root) {
    if (root.__hcd) return;
    var K;
    try { K = JSON.parse(root.querySelector('[data-hcd-data]').textContent); } catch (e) { return; }
    if (!K || !K.poly || !K.blade) return;
    root.__hcd = true;
    uid += 1;

    var panel = root.closest('[data-hc-engrave]') || document;
    var input = panel.querySelector('[data-hc-engrave-input]');
    var radios = Array.prototype.slice.call(panel.querySelectorAll('input[type="radio"]'));
    var svg = root.querySelector('[data-hcd-svg]');
    var sizeEl = root.querySelector('[data-hcd-size]');
    var sizeOut = root.querySelector('[data-hcd-size-out]');
    var statusEl = root.querySelector('[data-hcd-status]');
    var readEl = root.querySelector('[data-hcd-readout]');
    var logoFile = root.querySelector('[data-hcd-logo-file]');
    var logoRow = root.querySelector('[data-hcd-logo-row]');
    var logoName = root.querySelector('[data-hcd-logo-name]');
    var logoSize = root.querySelector('[data-hcd-logo-size]');
    var logoSizeOut = root.querySelector('[data-hcd-logo-size-out]');
    var logoMsg = root.querySelector('[data-hcd-logo-msg]');
    var activeRow = root.querySelector('[data-hcd-active-row]');
    var fields = {};
    root.querySelectorAll('[data-hcd-field]').forEach(function (i) { fields[i.getAttribute('data-hcd-field')] = i; });

    var M = K.margin || 1.5, PAD = K.keep_pad == null ? 1.5 : K.keep_pad, GAP = 1;
    var LOGO_MAX_MB = 10;
    var st = {
      side: 'front', size: +(sizeEl && sizeEl.value) || 5, fits: true, soft: true, active: 'text', mode: 'text',
      T: { x: null, y: null },
      L: { x: null, y: null, w: 20, ratio: 1, url: null, name: '' }
    };
    if (sizeEl && K.max_size) sizeEl.max = K.max_size;
    /* Menší nože: menší výchozí písmo (z metafieldu default_size). */
    if (K.default_size) {
      st.size = K.default_size;
      if (sizeEl) sizeEl.value = K.default_size;
      if (sizeOut) sizeOut.textContent = fmt(K.default_size) + ' mm';
    }
    var cs = getComputedStyle(root);
    var sg = function () { return st.side === 'back' ? -1 : 1; };
    var viewPoly = K.poly;
    var textEl, logoEl, selEl, scene;
    var mq = window.matchMedia('(max-width: 749px)');

    function family(fd) {
      var v = fd.v ? cs.getPropertyValue(fd.v).trim() : '';
      return (fd.fam ? fd.fam + ', ' : '') + (v || fd.fb);
    }
    function fontIdx() {
      for (var i = 0; i < radios.length; i++) if (radios[i].checked) return Math.min(i, FONTS.length - 1);
      return 0;
    }
    function fontName() {
      for (var i = 0; i < radios.length; i++) if (radios[i].checked) return radios[i].value;
      return '';
    }
    function typed() { return input ? input.value.trim() : ''; }
    function hasLogo() { return st.mode === 'logo' && !!st.L.url; }
    /* Gravíruje se buď text, nebo logo (přepínač nahoře v panelu). */
    function hasText() { return st.mode === 'text'; }
    function shown() {
      var t = typed() || 'Váš text';
      return FONTS[fontIdx()].upper ? t.toUpperCase() : t;
    }
    function keep(side) {
      var m = side === 'back' ? K.mark_back : K.mark_front;
      if (!m) return null;
      var k = { x0: m.x0 - PAD, x1: m.x1 + PAD, y0: m.y0 - PAD, y1: m.y1 + PAD };
      return side === 'back' ? { x0: -k.x1, x1: -k.x0, y0: k.y0, y1: k.y1 } : k;
    }
    function softRect() {
      var s = K.soft; if (!s) return null;
      return st.side === 'back' ? { x0: -s.x1, x1: -s.x0, y0: s.y0, y1: s.y1 } : s;
    }

    /* Rozměr nápisu v mm: šířka změřená písmem na canvasu (funguje i ve
       sbaleném panelu), výška = výška písmen s rezervou na diakritiku. */
    function metrics() {
      var fd = FONTS[fontIdx()], t = shown(), fs = st.size / fd.cap;
      ctx.font = (fd.italic ? 'italic ' : '') + '400 100px ' + family(fd);
      var w = ctx.measureText(t).width / 100 * fs + fd.ls * fs * t.length;
      return { w: w, h: st.size * (fd.italic ? 1.35 : 1.2), fs: fs, fd: fd, t: t };
    }
    function textBox(x, y) {
      if (!hasText() || x === null) return null;
      var mt = metrics();
      return { x: x - mt.w / 2, y: y - mt.h / 2, width: mt.w, height: mt.h };
    }
    function logoBox(x, y) {
      if (!hasLogo() || x === null) return null;
      var w = st.L.w, h = w / st.L.ratio;
      return { x: x - w / 2, y: y - h / 2, width: w, height: h };
    }
    function boxOf(which, x, y) { return which === 'logo' ? logoBox(x, y) : textBox(x, y); }
    function posOf(which) { return which === 'logo' ? st.L : st.T; }
    function other(which) { return which === 'logo' ? 'text' : 'logo'; }
    function overlap(a, b, g) {
      return a.x < b.x + b.width + g && a.x + a.width + g > b.x && a.y < b.y + b.height + g && a.y + a.height + g > b.y;
    }
    function hitsKeep(b) {
      var k = keep(st.side);
      return !!k && b.x < k.x1 && b.x + b.width > k.x0 && b.y < k.y1 && b.y + b.height > k.y0;
    }
    function onBlade(b) {
      if (hitsKeep(b)) return false;
      for (var i = 0; i <= 6; i++) for (var j = 0; j <= 3; j++) {
        var x = b.x + b.width * i / 6, y = b.y + b.height * j / 3;
        if (!inPoly(x, y, viewPoly) || distEdge(x, y, viewPoly) < M - 0.01) return false;
      }
      return true;
    }
    /* Vejde se objekt na místo x, y: na čepel, mimo značku a nepřekrývá druhý objekt. */
    function fitsAt(which, x, y) {
      var b = boxOf(which, x, y);
      if (!b) return true;
      if (!onBlade(b)) return false;
      var o = posOf(other(which)), ob = boxOf(other(which), o.x, o.y);
      return !(ob && overlap(b, ob, GAP));
    }
    /* Doporučená plocha: mnohoúhelník soft_poly (přesněji kopíruje čepel až ke špičce),
       starší data mají jen obdélník soft. */
    function softPoly() {
      if (!K.soft_poly) return null;
      return st.side === 'back' ? K.soft_poly.map(function (p) { return [-p[0], p[1]]; }) : K.soft_poly;
    }
    function inSoft(b) {
      if (!b) return true;
      var sp = softPoly();
      if (sp) {
        for (var i = 0; i <= 6; i++) for (var j = 0; j <= 3; j++) {
          if (!inPoly(b.x + b.width * i / 6, b.y + b.height * j / 3, sp)) return false;
        }
        return true;
      }
      var s = softRect();
      return !s || (b.x >= s.x0 - .01 && b.y >= s.y0 - .01 && b.x + b.width <= s.x1 + .01 && b.y + b.height <= s.y1 + .01);
    }
    function preferred() {
      var k = keep(st.side), s = K.soft || { y1: K.H * 0.7 };
      if (!k) return [sg() * K.L * 0.3, K.H * 0.4];
      return [(k.x0 + k.x1) / 2, (k.y1 + s.y1) / 2];
    }
    /* Místo vedle tovární značky: levý okraj nápisu 1 mm za ochrannou
       zónou značky, svislý střed na středu značky. Zkouší se i o 1–3 mm
       níž a výš (čepel se ke špičce zužuje). Null = nevejde se. */
    function besideMark(which) {
      if (which !== 'text') return null;
      var m = st.side === 'back' ? K.mark_back : K.mark_front, k = keep(st.side);
      if (!m || !k) return null;
      var b = boxOf(which, 0, 0);
      if (!b) return null;
      /* Odstup 6 mm od ochranné zóny značky (zóna je 1,5 mm kolem značky),
         tedy asi 7,5 mm od posledního znaku – klient 3. 11. 2026: „ať není
         úplně nalepené“. Když se tam nevejde, zkouší se blíž (3 mm, 1 mm). */
      var gaps = [6, 3, GAP], cx;
      var cy = (m.y0 + m.y1) / 2, dys = [0, 1, -1, 2, 3];
      for (var g = 0; g < gaps.length; g++) {
        cx = st.side === 'back' ? k.x0 - gaps[g] - b.width / 2 : k.x1 + gaps[g] + b.width / 2;
        for (var i = 0; i < dys.length; i++) {
          if (fitsAt(which, cx, cy + dys[i])) return [cx, cy + dys[i]];
        }
      }
      return null;
    }
    /* Najde nejbližší místo, kam se objekt vejde (od bodu px, py). */
    function place(which, px, py) {
      var c = [];
      for (var x = 0; x <= K.L; x += 1.5) for (var y = 0; y <= K.H; y += 1) {
        var vx = sg() * x;
        c.push([vx, y, (vx - px) * (vx - px) + (y - py) * (y - py) * 4]);
      }
      c.sort(function (a, b) { return a[2] - b[2]; });
      var p = posOf(which);
      for (var i = 0; i < c.length; i++) {
        if (fitsAt(which, c[i][0], c[i][1])) { p.x = c[i][0]; p.y = c[i][1]; return true; }
      }
      return false;
    }
    function relocate(which) {
      var p = posOf(which);
      if (!boxOf(which, p.x === null ? 0 : p.x, p.y === null ? 0 : p.y)) return;
      if (p.x === null) {
        var q = preferred();
        if (which === 'logo') q = [q[0] + sg() * 45, q[1]];
        p.x = q[0]; p.y = q[1];
        /* Výchozí místo nápisu je vedle tovární značky (směrem ke špičce),
           ve stejné výšce jako značka – přání klienta z 3. 11. 2026.
           Když se tam nevejde, zůstává dřívější místo pod značkou. */
        var bq = besideMark(which);
        if (bq) { p.x = bq[0]; p.y = bq[1]; }
      }
      if (!fitsAt(which, p.x, p.y) && !place(which, p.x, p.y)) {
        var r = preferred(); p.x = r[0]; p.y = r[1];
      }
    }

    function draw() {
      var back = st.side === 'back';
      viewPoly = back ? K.poly.map(function (p) { return [-p[0], p[1]]; }) : K.poly;
      /* Na mobilu jen čepel bez rukojeti, ať je nápis co největší. */
      var narrow = mq.matches;
      var lead = narrow ? 6 : 30, tail = narrow ? 3 : 8;
      var vw = K.L + lead + tail, vx = back ? -(K.L + tail) : -lead;
      svg.setAttribute('viewBox', vx + ' ' + (narrow ? -3 : -8) + ' ' + vw + ' ' + (K.H + (narrow ? 14 : 22)));
      svg.replaceChildren();
      var id = 'hcd' + uid;
      var defs = el('defs', {}, svg);
      var g1 = el('linearGradient', { id: id + 's', x1: 0, y1: 0, x2: 0, y2: 1 }, defs);
      [['0', '#F3F4F5'], ['.35', '#D9DDE0'], ['.55', '#BFC5CA'], ['.86', '#E6E9EB'], ['1', '#F6F7F8']]
        .forEach(function (s) { el('stop', { offset: s[0], 'stop-color': s[1] }, g1); });
      var g2 = el('linearGradient', { id: id + 'w', x1: 0, y1: 0, x2: 0, y2: 1 }, defs);
      [['0', '#3A3F46'], ['.5', '#1D2126'], ['1', '#2B3036']]
        .forEach(function (s) { el('stop', { offset: s[0], 'stop-color': s[1] }, g2); });
      /* Logo jako gravura: šedotónově a tmavě, jak ho udělá laser. */
      var flt = el('filter', { id: id + 'g', 'color-interpolation-filters': 'sRGB' }, defs);
      el('feColorMatrix', { type: 'saturate', values: '0' }, flt);

      scene = el('g', {}, svg);
      var art = el('g', back ? { transform: 'scale(-1,1)' } : {}, scene);
      if (K.handle) el('path', { d: K.handle, fill: 'url(#' + id + 'w)' }, art);
      (K.parts || []).forEach(function (d) { el('path', { d: d, fill: '#AEB4BA' }, art); });
      (K.rivets || []).forEach(function (r) { el('circle', { cx: r[0], cy: r[1], r: r[2], fill: '#C9CED2' }, art); });
      el('path', { d: K.blade, fill: 'url(#' + id + 's)', stroke: '#7D858C', 'stroke-width': .3 }, art);

      var s = softRect(), sp = softPoly();
      if (sp) el('path', { d: 'M' + sp.map(function (p) { return p[0] + ',' + p[1]; }).join(' L') + ' Z', fill: 'none',
        stroke: '#1B2835', 'stroke-width': .3, 'stroke-dasharray': '1.6 1.2', 'stroke-linejoin': 'round', opacity: .4 }, scene);
      else if (s) el('rect', { x: s.x0, y: s.y0, width: s.x1 - s.x0, height: s.y1 - s.y0, rx: 1, fill: 'none',
        stroke: '#1B2835', 'stroke-width': .3, 'stroke-dasharray': '1.6 1.2', opacity: .4 }, scene);

      var k = keep(st.side), m = back ? K.mark_back : K.mark_front;
      if (k) {
        el('rect', { x: k.x0, y: k.y0, width: k.x1 - k.x0, height: k.y1 - k.y0, rx: 1, fill: '#B63233',
          'fill-opacity': .08, stroke: '#B63233', 'stroke-width': .3, 'stroke-opacity': .7 }, scene);
        var cy = (k.y0 + k.y1) / 2;
        if (m.glyphs && m.glyphs.length) {
          /* Znaky psané svisle, na ležícím noži otočené o 90°, čtou se od špičky k patě. */
          var step = (m.x1 - m.x0) / m.glyphs.length;
          m.glyphs.forEach(function (ch, i) {
            var cx = sg() * (m.x1 - step * (i + .5));
            var t = el('text', { x: cx, y: cy, 'text-anchor': 'middle', 'dominant-baseline': 'central',
              transform: 'rotate(90 ' + cx + ' ' + cy + ')', 'font-size': Math.min(10, step * 0.85),
              'font-family': "'Noto Serif JP','Hiragino Mincho ProN','Yu Mincho',serif",
              fill: '#F7F8F9', stroke: '#6F777E', 'stroke-width': .3 }, scene);
            t.textContent = ch;
          });
        } else if (m.label) {
          var t2 = el('text', { x: (k.x0 + k.x1) / 2, y: cy, 'text-anchor': 'middle', 'dominant-baseline': 'central',
            'font-size': 3, 'font-family': 'Arial, sans-serif', 'font-weight': 700, fill: '#3A3F44' }, scene);
          t2.textContent = m.label;
        }
        if (K.H - k.y1 > 14) {
          var lb = el('text', { x: k.x0, y: k.y1 + 2.6, 'font-size': 2.2, 'font-family': 'Lato, Arial, sans-serif', fill: '#8E2426' }, scene);
          lb.textContent = 'Tovární značka – sem gravírovat nejde';
        }
      }

      var ry = K.H + 4, ruler = el('g', { fill: '#6E6C69', 'font-size': 3, 'font-family': 'Lato, Arial, sans-serif' }, scene);
      el('line', { x1: 0, y1: ry, x2: sg() * K.L, y2: ry, stroke: '#9A968F', 'stroke-width': .3 }, ruler);
      for (var x = 0; x <= K.L; x += 10) {
        el('line', { x1: sg() * x, y1: ry, x2: sg() * x, y2: ry + (x % 50 ? 1.2 : 2.4), stroke: '#9A968F', 'stroke-width': .3 }, ruler);
        if (x % 50 === 0) { var rt = el('text', { x: sg() * x, y: ry + 6, 'text-anchor': 'middle' }, ruler); rt.textContent = x + ' mm'; }
      }

      logoEl = el('image', { class: 'hcd__logo', preserveAspectRatio: 'none', filter: 'url(#' + id + 'g)', opacity: .82 }, scene);
      logoEl.style.mixBlendMode = 'multiply';
      textEl = el('text', { class: 'hcd__text', 'text-anchor': 'middle', 'dominant-baseline': 'central', fill: '#23282C' }, scene);
      selEl = el('rect', { fill: 'none', stroke: '#1B2835', 'stroke-width': .35, 'stroke-dasharray': '1 .8', rx: .8 }, scene);
      update(true);
    }

    function update(reloc) {
      if (reloc) { relocate('text'); relocate('logo'); }
      var tb = textBox(st.T.x, st.T.y), lb = logoBox(st.L.x, st.L.y);
      var tFits = !tb || fitsAt('text', st.T.x, st.T.y), lFits = !lb || fitsAt('logo', st.L.x, st.L.y);
      st.fits = tFits && lFits;
      st.soft = inSoft(tb) && inSoft(lb);
      st.active = st.mode;

      var mt = metrics();
      textEl.style.display = tb ? '' : 'none';
      if (tb) {
        textEl.textContent = mt.t;
        textEl.setAttribute('x', st.T.x); textEl.setAttribute('y', st.T.y);
        textEl.setAttribute('font-size', mt.fs.toFixed(3));
        textEl.setAttribute('font-family', family(mt.fd));
        textEl.setAttribute('font-style', mt.fd.italic ? 'italic' : 'normal');
        textEl.style.letterSpacing = mt.fd.ls ? (mt.fd.ls * mt.fs).toFixed(3) + 'px' : '';
        textEl.setAttribute('fill-opacity', typed() ? .85 : .4);
      }
      logoEl.style.display = lb ? '' : 'none';
      if (lb) {
        logoEl.setAttribute('href', st.L.url);
        logoEl.setAttribute('x', lb.x); logoEl.setAttribute('y', lb.y);
        logoEl.setAttribute('width', lb.width); logoEl.setAttribute('height', lb.height);
      }
      /* Rámeček kolem toho, co se právě posouvá (jen když jsou na čepeli dvě věci). */
      var ab = st.active === 'logo' ? lb : tb;
      selEl.style.display = tb && lb && ab ? '' : 'none';
      if (ab) { selEl.setAttribute('x', ab.x - .8); selEl.setAttribute('y', ab.y - .8); selEl.setAttribute('width', ab.width + 1.6); selEl.setAttribute('height', ab.height + 1.6); }
      if (activeRow) {
        activeRow.hidden = !(tb && lb);
        activeRow.querySelectorAll('[data-hcd-active]').forEach(function (b) {
          b.setAttribute('aria-pressed', String(b.getAttribute('data-hcd-active') === st.active));
        });
      }

      var heel = function (b) { return st.side === 'back' ? -(b.x + b.width) : b.x; };
      var desc = function (b) { return fmt(b.width) + ' × ' + fmt(b.height) + ' mm, ' + fmt(heel(b)) + ' mm od záštity, ' + fmt(b.y) + ' mm od hřbetu'; };
      if (readEl) {
        var lines = [];
        if (tb) lines.push('Nápis ' + fmt(tb.width) + ' × ' + fmt(st.size) + ' mm · ' + fmt(heel(tb)) + ' mm od záštity · ' + fmt(tb.y) + ' mm od hřbetu');
        if (lb) lines.push('Logo ' + fmt(lb.width) + ' × ' + fmt(lb.height) + ' mm · ' + fmt(heel(lb)) + ' mm od záštity · ' + fmt(lb.y) + ' mm od hřbetu');
        if (st.mode === 'logo' && !lb) lines.push('Nahrajte logo, pak ho můžete na čepeli posouvat.');
        readEl.textContent = lines.join('\n');
      }
      if (statusEl) {
        var what = !tFits && !lFits ? 'Nápis ani logo se' : !lFits ? 'Logo se' : 'Nápis se';
        statusEl.textContent = !st.fits
          ? what + ' na čepel nevejde. Zmenšete ' + (!lFits && tFits ? 'logo' : 'písmo nebo zkraťte text') + '.'
          : st.soft ? 'Umístění je v pořádku.' : 'Gravírování je blízko ostří nebo špičky. Jde to, ale doporučujeme ho posunout do vyznačené plochy.';
        statusEl.setAttribute('data-state', !st.fits ? 'bad' : st.soft ? 'ok' : 'warn');
      }

      var mark = st.side === 'back' ? K.mark_back : K.mark_front;
      var sideTxt = (st.side === 'back' ? 'zadní' : 'přední') + (mark && mark.label ? ' (se značkou ' + mark.label + ')' : '');
      var hasT = st.mode === 'text' && !!typed();
      if (fields.strana) fields.strana.value = sideTxt;
      if (fields.vyska) fields.vyska.value = hasT ? fmt(st.size) + ' mm' : '';
      if (fields.umisteni) fields.umisteni.value = hasT && tb ? fmt(heel(tb)) + ' mm od záštity, ' + fmt(tb.y) + ' mm od hřbetu (nápis ' + fmt(tb.width) + ' × ' + fmt(st.size) + ' mm)' : '';
      if (fields.logo) fields.logo.value = lb ? 'ano – ' + desc(lb) : '';
      var r2 = function (n) { return +n.toFixed(2); };
      if (fields.data) fields.data.value = JSON.stringify({
        nuz: K.nuz || '', strana: st.side,
        text: hasT && tb ? { napis: shown(), pismo: fontName(), vyska_mm: st.size, stred_x: r2(st.T.x), stred_y: r2(st.T.y),
          od_zastity: r2(heel(tb)), od_hrbetu: r2(tb.y), sirka: r2(tb.width) } : null,
        logo: lb ? { soubor: st.L.name, stred_x: r2(st.L.x), stred_y: r2(st.L.y), od_zastity: r2(heel(lb)),
          od_hrbetu: r2(lb.y), sirka: r2(lb.width), vyska: r2(lb.height) } : null,
        kontrola: !st.fits ? 'nevejde se' : st.soft ? 'ok' : 'blizko ostri'
      });
      laserSchedule();
    }

    /* ── SVG pro laser (hobbychef-engrave-laser.js): po změně návrhu s prodlevou
       načte písmo, při odeslání formuláře vloží hotové SVG 1:1 do skrytého pole
       [data-hcd-laser]; košík ho nahraje k položce gravírování. */
    var laserInput = root.querySelector('[data-hcd-laser]'), laserTimer = null, laserLogo = { file: null, href: '' };
    function laserClear() { if (laserInput && laserInput.files && laserInput.files.length) { try { laserInput.value = ''; } catch (e) {} } }
    function laserFile() { var lf = root.querySelector('[data-hcd-logo-file]'); return lf && lf.files && lf.files[0] || null; }
    function laserSchedule() {
      if (!laserInput || !window.HCLaser) return;
      laserClear();
      clearTimeout(laserTimer);
      laserTimer = setTimeout(function () {
        var jobs = [], f = laserFile();
        if (hasText()) jobs.push(window.HCLaser.load(fontIdx()));
        if (hasLogo() && f && laserLogo.file !== f) jobs.push(new Promise(function (res) {
          var fr = new FileReader();
          fr.onload = function () { laserLogo = { file: f, href: fr.result }; res(); };
          fr.onerror = function () { res(); };
          fr.readAsDataURL(f);
        }));
        Promise.all(jobs).then(laserBuild, function () {});
      }, 500);
    }
    function laserBuild() {
      if (!laserInput || !window.HCLaser || toggleOff()) return false;
      var tb = textBox(st.T.x, st.T.y), lb = logoBox(st.L.x, st.L.y), mt = metrics(), f = laserFile(), out = null;
      try {
        out = window.HCLaser.svg({
          K: K,
          popis: tb ? 'Nápis: ' + mt.t + ' (' + fontName() + ', ' + fmt(st.size) + ' mm).' : 'Logo: ' + (st.L.name || '') + '.',
          text: tb ? { t: mt.t, fi: fontIdx(), fs: mt.fs, ls: mt.fd.ls || 0, x: st.T.x, y: st.T.y } : null,
          logo: lb && f && laserLogo.file === f ? { x: lb.x, y: lb.y, w: lb.width, h: lb.height, href: laserLogo.href } : null
        });
      } catch (e) { out = null; }
      if (!out) { laserClear(); return false; }
      try {
        var slug = String(K.nuz || 'nuz').normalize('NFD').replace(/[̀-ͯ]/g, '').toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, '');
        var dt = new DataTransfer();
        dt.items.add(new File([out], 'gravirovani-' + slug + '.svg', { type: 'image/svg+xml' }));
        laserInput.files = dt.files;
        return true;
      } catch (e) { return false; }
    }
    /* Když SVG při odeslání nejde sestavit (písmo se ještě nenačetlo – zákazník
       odeslal hned, nebo s textem vůbec nehnul a načítání ještě běží), odeslání
       se podrží, písmo se dotáhne a formulář se odešle znovu. Nejvýš 8 s, pak
       odejde i bez SVG, aby nákup nikdy nezamrzl. */
    var laserWait = false;
    if (input && input.form) window.addEventListener('submit', function (e) {
      if (e.target !== input.form || toggleOff()) return;
      if (laserBuild() || laserWait || !window.HCLaser) return;
      var form = input.form, sub = e.submitter || null, again = function () {
        laserBuild();
        laserWait = true;
        try { form.requestSubmit ? form.requestSubmit(sub) : form.submit(); } finally { laserWait = false; }
      };
      e.preventDefault(); e.stopImmediatePropagation();
      var jobs = [];
      if (hasText()) jobs.push(window.HCLaser.load(fontIdx()));
      var stop = new Promise(function (res) { setTimeout(res, 8000); });
      Promise.race([Promise.all(jobs), stop]).then(again, again);
    }, true);

    function toSvg(e) {
      var p = svg.createSVGPoint(); p.x = e.clientX; p.y = e.clientY;
      return p.matrixTransform(scene.getScreenCTM().inverse());
    }
    /* Posun co nejblíž k cíli: zvlášť vodorovně a svisle, objekt „klouže“ podél okraje. */
    function moveTo(which, nx, ny) {
      var p = posOf(which), x0 = p.x, y0 = p.y;
      var ok = function (x, y) { return fitsAt(which, x, y); };
      /* Cíl se vejde: skočit rovnou tam (i přes úzké místo, kudy by se nápis neprotáhl). */
      if (ok(nx, ny)) { p.x = nx; p.y = ny; update(false); return; }
      /* Jinak nejbližší místo, kam se vejde, v okolí 6 mm od prstu/myši. */
      var best = null, bd = Infinity;
      for (var dx = -6; dx <= 6; dx += 1) for (var dy = -6; dy <= 6; dy += 1) {
        var d = dx * dx + dy * dy; if (d >= bd || d > 36) continue;
        if (ok(nx + dx, ny + dy)) { bd = d; best = [nx + dx, ny + dy]; }
      }
      if (best) { p.x = best[0]; p.y = best[1]; update(false); return; }
      var slide = function (ax, ay, bx, by) {
        if (ok(bx, by)) return [bx, by];
        if (!ok(ax, ay)) return [ax, ay];
        var lo = 0, hi = 1;
        for (var i = 0; i < 14; i++) { var m = (lo + hi) / 2; if (ok(ax + (bx - ax) * m, ay + (by - ay) * m)) lo = m; else hi = m; }
        return [ax + (bx - ax) * lo, ay + (by - ay) * lo];
      };
      var a = slide(x0, y0, nx, y0);
      var c = slide(a[0], a[1], a[0], ny);
      p.x = c[0]; p.y = c[1];
      update(false);
    }
    function near(b, p, pad) {
      return !!b && p.x >= b.x - pad && p.x <= b.x + b.width + pad && p.y >= b.y - pad && p.y <= b.y + b.height + pad;
    }

    /* Tažení je navázané na celý obrázek: chycení kolem nápisu nebo loga ho
       táhne, ťuknutí jinam na čepel tam přesune to, co je právě vybrané. */
    var drag = null;
    svg.addEventListener('pointerdown', function (e) {
      if (toggleOff()) return;
      if (st.mode === 'logo' && !st.L.url) return;
      if (e.pointerType === 'mouse' && e.button !== 0) return;
      var p = toSvg(e), pad = e.pointerType === 'mouse' ? 2 : 7;
      var tb = textBox(st.T.x, st.T.y), lb = logoBox(st.L.x, st.L.y);
      var nl = hasLogo() && near(lb, p, pad), nt = hasText() && near(tb, p, pad);
      if (nl && nt) st.active = near(lb, p, 0) || !near(tb, p, 0) ? 'logo' : 'text';
      else if (nl) st.active = 'logo';
      else if (nt) st.active = 'text';
      else {
        if (!inPoly(p.x, p.y, viewPoly)) return;
        var w = st.active = (st.mode === 'logo' ? 'logo' : 'text'), q = posOf(w);
        if (fitsAt(w, p.x, p.y)) { q.x = p.x; q.y = p.y; }
        else place(w, p.x, p.y);
      }
      update(false);
      e.preventDefault();
      try { svg.setPointerCapture(e.pointerId); } catch (err) {}
      var a = posOf(st.active);
      drag = { id: e.pointerId, which: st.active, dx: a.x - p.x, dy: a.y - p.y };
      root.classList.add('is-dragging');
    });
    svg.addEventListener('pointermove', function (e) {
      if (!drag || e.pointerId !== drag.id) return;
      e.preventDefault();
      var p = toSvg(e);
      moveTo(drag.which, p.x + drag.dx, p.y + drag.dy);
    });
    var endDrag = function () { drag = null; root.classList.remove('is-dragging'); };
    svg.addEventListener('pointerup', endDrag);
    svg.addEventListener('pointercancel', endDrag);
    /* Starší Safari: během tažení nenechat stránku rolovat. */
    svg.addEventListener('touchmove', function (e) { if (drag) e.preventDefault(); }, { passive: false });

    /* Jemný posun šipkami (po 1 mm), hodí se hlavně na telefonu. */
    root.querySelectorAll('[data-hcd-nudge]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var d = btn.getAttribute('data-hcd-nudge').split(','), p = posOf(st.active);
        if (p.x === null) return;
        moveTo(st.active, p.x + +d[0], p.y + +d[1]);
      });
    });
    root.querySelectorAll('[data-hcd-active]').forEach(function (btn) {
      btn.addEventListener('click', function () { st.active = btn.getAttribute('data-hcd-active'); update(false); });
    });

    root.querySelectorAll('[data-hcd-side]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var side = btn.getAttribute('data-hcd-side');
        if (side === st.side) return;
        root.querySelectorAll('[data-hcd-side]').forEach(function (x) { x.setAttribute('aria-pressed', String(x === btn)); });
        st.side = side; st.T.x = st.T.y = st.L.x = st.L.y = null; draw();
      });
    });
    if (sizeEl) sizeEl.addEventListener('input', function () {
      st.size = +sizeEl.value;
      if (sizeOut) sizeOut.textContent = fmt(st.size) + ' mm';
      st.active = 'text';
      update(true);
    });
    panel.addEventListener('input', function (e) { if (e.target === input) update(true); });
    panel.addEventListener('change', function (e) { if (e.target.type === 'radio') update(true); });

    /* Logo: soubor zůstává ve file inputu (odešle se s položkou gravírování),
       náhled se kreslí z lokální kopie v prohlížeči. */
    function logoError(msg) {
      if (logoMsg) { logoMsg.textContent = msg; logoMsg.hidden = !msg; }
    }
    function clearLogo() {
      if (st.L.url) { try { URL.revokeObjectURL(st.L.url); } catch (e) {} }
      st.L.url = null; st.L.name = ''; st.L.x = st.L.y = null;
      if (logoFile) logoFile.value = '';
      if (logoRow) logoRow.hidden = true;
      st.active = 'text';
    }
    function revalidateText() {
      /* hobbychef-engrave.js hlídá povinný text; s logem už povinný není. */
      if (input) input.dispatchEvent(new Event('input', { bubbles: true }));
    }
    function svgRatio(txt) {
      var vb = txt.match(/viewBox\s*=\s*["']\s*[-\d.]+[\s,]+[-\d.]+[\s,]+([\d.]+)[\s,]+([\d.]+)/i);
      if (vb && +vb[1] > 0 && +vb[2] > 0) return +vb[1] / +vb[2];
      var w = txt.match(/<svg[^>]*\swidth\s*=\s*["']([\d.]+)/i), h = txt.match(/<svg[^>]*\sheight\s*=\s*["']([\d.]+)/i);
      return w && h && +w[1] > 0 && +h[1] > 0 ? +w[1] / +h[1] : 0;
    }
    function setLogo(file, ratio, url) {
      st.L.url = url; st.L.name = file.name; st.L.ratio = ratio > 0 ? ratio : 1;
      /* Výchozí velikost: 25 mm na šířku, ale nejvýš 16 mm na výšku. */
      st.L.w = Math.max(5, Math.min(25, 16 * st.L.ratio));
      if (logoSize) { logoSize.value = Math.round(st.L.w); }
      if (logoSizeOut) logoSizeOut.textContent = Math.round(st.L.w) + ' mm';
      if (logoName) logoName.textContent = file.name;
      if (logoRow) logoRow.hidden = false;
      st.L.x = st.L.y = null; st.active = 'logo';
      update(true);
      revalidateText();
    }
    if (logoFile) logoFile.addEventListener('change', function () {
      var file = logoFile.files && logoFile.files[0];
      logoError('');
      if (!file) { clearLogo(); update(false); revalidateText(); return; }
      var okType = /^image\/(png|jpeg|svg\+xml)$/.test(file.type) || /\.(png|jpe?g|svg)$/i.test(file.name);
      if (!okType) { clearLogo(); update(false); revalidateText(); logoError('Nahrajte logo jako PNG, JPG nebo SVG.'); return; }
      if (file.size > LOGO_MAX_MB * 1024 * 1024) { clearLogo(); update(false); revalidateText(); logoError('Soubor je větší než ' + LOGO_MAX_MB + ' MB. Zkuste menší.'); return; }
      if (st.L.url) { try { URL.revokeObjectURL(st.L.url); } catch (e) {} }
      var url = URL.createObjectURL(file);
      var isSvg = /svg/i.test(file.type) || /\.svg$/i.test(file.name);
      var img = new Image();
      img.onload = function () {
        var r = img.naturalWidth && img.naturalHeight ? img.naturalWidth / img.naturalHeight : 0;
        if (isSvg && file.text) file.text().then(function (t) { setLogo(file, svgRatio(t) || r, url); }, function () { setLogo(file, r, url); });
        else setLogo(file, r, url);
      };
      img.onerror = function () { clearLogo(); update(false); revalidateText(); logoError('Soubor se nepodařilo načíst. Zkuste jiný formát.'); };
      img.src = url;
    });
    root.querySelectorAll('[data-hcd-logo-remove]').forEach(function (b) {
      b.addEventListener('click', function () { clearLogo(); logoError(''); update(true); revalidateText(); });
    });
    if (logoSize) logoSize.addEventListener('input', function () {
      st.L.w = +logoSize.value;
      if (logoSizeOut) logoSizeOut.textContent = st.L.w + ' mm';
      st.active = 'logo';
      update(true);
    });

    /* Přepínač Text / Logo. Pole textu a výběr písma jsou v hc-engrave mimo
       návrhář, v režimu Logo se schovají a vypnou (neodešlou se, text
       přestane být povinný). Soubor loga se v režimu Text neodesílá. */
    var modeRow = root.querySelector('[data-hcd-mode-row]');
    if (modeRow && panel !== document) panel.insertBefore(modeRow, panel.firstElementChild);
    var textField = input ? (input.closest('.hc-pm__engrave-field') || input.closest('label')) : null;
    var fontsBox = panel.querySelector('.hc-pm__engrave-fonts');
    var errBox = panel.querySelector('[data-hc-engrave-error]');
    function applyMode() {
      var logo = st.mode === 'logo';
      root.querySelectorAll('[data-hcd-for]').forEach(function (n) { n.hidden = n.getAttribute('data-hcd-for') !== st.mode; });
      if (modeRow) modeRow.querySelectorAll('[data-hcd-mode]').forEach(function (b) {
        b.setAttribute('aria-pressed', String(b.getAttribute('data-hcd-mode') === st.mode));
      });
      var on = !toggleOff();
      if (textField) textField.style.display = logo ? 'none' : '';
      if (fontsBox) fontsBox.style.display = logo ? 'none' : '';
      if (errBox && logo) errBox.hidden = true;
      if (input) input.disabled = logo || !on;
      radios.forEach(function (r) { r.disabled = logo || !on; });
      if (logoFile) logoFile.disabled = !logo || !on;
      if (input && logo) { input.classList.remove('is-invalid'); input.removeAttribute('aria-invalid'); }
      logoError('');
    }
    function toggleOff() {
      var t = panel.id ? document.querySelector('[data-hc-engrave-toggle][aria-controls="' + panel.id + '"]') : null;
      return !!t && !t.checked;
    }
    function setMode(m) {
      if (m === st.mode) return;
      st.mode = m; st.active = m;
      applyMode();
      update(true);
      revalidateText();
    }
    if (modeRow) modeRow.querySelectorAll('[data-hcd-mode]').forEach(function (b) {
      b.addEventListener('click', function () { setMode(b.getAttribute('data-hcd-mode')); });
    });
    /* hobbychef-engrave.js při zapnutí gravírování povolí všechna pole panelu,
       proto po něm režim znovu uplatnit. */
    document.addEventListener('change', function (e) {
      if (e.target && e.target.matches && e.target.matches('[data-hc-engrave-toggle]')) setTimeout(applyMode, 0);
    });

    /* Vzorky písma: jedna řádka, stejná výška, dlouhý text se zmenší. */
    function fitSamples() {
      if (!fontsBox) return;
      fontsBox.querySelectorAll('[data-hc-engrave-sample]').forEach(function (el) {
        el.style.fontSize = '';
        if (!el.clientWidth) return;
        for (var k = 0; k < 3; k++) {
          var over = el.scrollWidth / el.clientWidth;
          if (over <= 1.01) break;
          el.style.fontSize = Math.max(8, parseFloat(getComputedStyle(el).fontSize) / over * 0.98) + 'px';
        }
      });
    }
    function fitSoon() { requestAnimationFrame(function () { requestAnimationFrame(fitSamples); }); }
    panel.addEventListener('input', function (e) { if (e.target === input) fitSoon(); });
    window.addEventListener('resize', fitSoon);
    document.addEventListener('change', function (e) {
      if (e.target && e.target.matches && e.target.matches('[data-hc-engrave-toggle]')) setTimeout(fitSoon, 50);
    });

    /* Nepustit do košíku nic, co se na čepel nevejde. */
    var form = input && input.form;
    if (form) window.addEventListener('submit', function (e) {
      if (e.target !== form || toggleOff()) return;
      var noLogo = st.mode === 'logo' && !hasLogo();
      if (st.fits && !noLogo) return;
      e.preventDefault(); e.stopImmediatePropagation();
      if (noLogo) logoError('Nahrajte prosím logo, nebo přepněte na Text.');
      root.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }, true);

    if (mq.addEventListener) mq.addEventListener('change', draw);
    applyMode();
    draw();
    fitSoon();
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(function () { update(true); fitSamples(); });
  }

  function initAll() { document.querySelectorAll('[data-hc-engrave-designer]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAll);
  else initAll();
  window.hcEngraveDesigner = { init: initAll };
})();
